// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ImgResponsive":"rg_a vh_a vh_q vh_j vh_sk vh_bi","ImgResponsive__img":"rg_b vh_b vh_mw"};